import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { ListSubheader } from '@mui/material';
import { PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE, PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_GREY_700, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_SUCCESS_GREEN, PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER, PROMETHEAN_TEXT_INPUT_LABEL } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_EYEBROW, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 } from '../../styles/typography/typography';
export var InputSelectContainer = styled('div')({
  label: 'InputSelectContainer',
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  verticalAlign: 'top',
  marginTop: 7,
  width: '100%'
});
export var SelectGroupSubheader = styled(ListSubheader)({
  '&.SelectGroupItem-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
    textTransform: 'uppercase',
    // height: 29, // not sure if this is necessary
    margin: '2px 16px',
    padding: '9px 0 0',
    borderBottom: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_GREY)
  })
});
export var InputSelectAlertText = styled('div')(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
  marginTop: 5,
  marginLeft: 16,
  marginRight: 8,
  position: 'relative',
  '.EmbersInputSelect-alertText-error': {
    color: PROMETHEAN_ERROR_OR_DESTRUCT
  },
  '.EmbersInputSelect-alertText-success': {
    color: PROMETHEAN_SUCCESS_GREEN
  },
  '&.EmbersInputSelect-alertText-dark': {
    '.EmbersInputSelect-alertText-error, .EmbersInputSelect-alertText-success': {
      color: PROMETHEAN_NEUTRAL_WHITE,
      marginLeft: 20
    }
  }
}));
export var InputSelectHelperText = styled('div')(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
  marginTop: 4,
  marginLeft: 17,
  marginRight: 8,
  '&.EmbersInputSelect-helperText-dark': {
    color: PROMETHEAN_NEUTRAL_WHITE
  },
  '&.EmbersInputSelect-helperText-disabled': {
    color: PROMETHEAN_NEUTRAL_DARK_GREY
  }
}));
export var InputSelectDarkLabel = styled('div')(_objectSpread(_objectSpread({
  position: 'absolute',
  top: 3,
  left: 15
}, PROMETHEAN_TYPOGRAPHY_EYEBROW), {}, {
  '&.EmbersInputSelect-darkLabel-disabled': {
    color: PROMETHEAN_NEUTRAL_DARK_GREY
  },
  '&.EmbersInputSelect-darkLabel-required': {
    '.EmbersInputSelect-darkLabel-required-postfix': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT,
      lineHeight: '14px'
    }
  }
}));
export var InputSelectFieldset = styled('fieldset')({
  position: 'absolute',
  pointerEvents: 'none',
  padding: 0,
  margin: 0,
  top: -8,
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: 4,
  border: '1px solid ' + PROMETHEAN_NEUTRAL_GREY_700,
  '&.SelectLaunchButton-fieldset-emptyLegend': {
    top: 0
  },
  color: PROMETHEAN_TEXT,
  legend: {
    overflow: 'visible',
    textAlign: 'start',
    fontSize: 12,
    lineHeight: '16px',
    paddingLeft: 5,
    paddingRight: 5,
    marginLeft: 8,
    backgroundColor: 'transparent',
    transform: 'translate(0px, 4px)',
    '&:has(.EmbersInputSelect-legend-requiredPostfix)': {
      '.EmbersInputSelect-legend-requiredPostfix': {
        color: PROMETHEAN_ERROR_OR_DESTRUCT,
        lineHeight: '14px'
      }
    }
  },
  '&.SelectLaunchButton-fieldset-menuIsOpen': {
    border: '1px solid ' + PROMETHEAN_PURPLE_GRAPE
  },
  '&.SelectLaunchButton-fieldset-focusVisible': {
    border: '2px solid ' + PROMETHEAN_BLUE,
    '&.SelectLaunchButton-fieldset-emptyLegend': {
      top: -8
    },
    legend: {
      marginLeft: 7,
      paddingBottom: 1
    }
  },
  '&:not(.SelectLaunchButton-fieldset-focusVisible)': {
    '&.SelectLaunchButton-fieldset-error': {
      borderColor: PROMETHEAN_ERROR_OR_DESTRUCT
    },
    '&.SelectLaunchButton-fieldset-success': {
      borderColor: PROMETHEAN_SUCCESS_GREEN
    },
    '&.SelectLaunchButton-fieldset-disabled': {
      borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
      color: PROMETHEAN_NEUTRAL_DARK_GREY
    }
  },
  '&.SelectLaunchButton-fieldset-disabled': {
    borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
    color: PROMETHEAN_NEUTRAL_DARK_GREY
  },
  '&.SelectLaunchButton-fieldset-dark': {
    borderWidth: 2,
    '&.SelectLaunchButton-fieldset-disabled': {
      borderColor: PROMETHEAN_NEUTRAL_DARK_GREY
    },
    '&.SelectLaunchButton-fieldset-focusVisible': {
      top: 2,
      right: 2,
      bottom: 2,
      left: 2,
      borderRadius: 2,
      border: '1px solid ' + PROMETHEAN_DARK_PURPLE,
      '&.SelectLaunchButton-fieldset-error': {
        borderWidth: 2,
        borderColor: PROMETHEAN_ERROR_OR_DESTRUCT
      },
      '&.SelectLaunchButton-fieldset-success': {
        borderWidth: 2,
        borderColor: PROMETHEAN_SUCCESS_GREEN
      }
    }
  }
});
export var InputSelectAlertFocusFieldset = styled('fieldset')({
  position: 'absolute',
  pointerEvents: 'none',
  padding: 0,
  margin: 0,
  top: 3,
  bottom: 3,
  left: 3,
  right: 3,
  borderRadius: 2,
  borderWidth: 1,
  borderStyle: 'solid',
  '&.SelectLaunchButton-alertFieldset-error': {
    borderColor: PROMETHEAN_ERROR_OR_DESTRUCT
  },
  '&.SelectLaunchButton-alertFieldset-success': {
    borderColor: PROMETHEAN_SUCCESS_GREEN
  },
  '&.SelectLaunchButton-alertFieldset-disabled': {
    // this should never happen - disabled and tab-focussed - but wth
    borderColor: PROMETHEAN_NEUTRAL_DARK_GREY
  },
  legend: {
    marginLeft: 5
  }
});
export var StyledInputSelectLabel = styled('label')(_objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  color: PROMETHEAN_TEXT_INPUT_LABEL,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  '&.EmbersInputSelect-label-disabled': {
    color: PROMETHEAN_NEUTRAL_DARK_GREY
  },
  '&.EmbersInputSelect-label-required': {
    display: 'flex',
    '.EmbersInputSelect-label-required-text': {
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '.EmbersInputSelect-label-required-postfix': {
      color: PROMETHEAN_ERROR_OR_DESTRUCT,
      lineHeight: '14px',
      paddingTop: 4
    }
  },
  '&.EmbersInputSelect-label-menuOpen': {
    display: 'none'
  },
  '&.EmbersInputSelect-label-labelIsInCorner': {
    display: 'none'
  },
  '&.EmbersInputSelect-label-focusVisible': {
    display: 'none'
  },
  '&.EmbersInputSelect-label-clickFocused': {
    display: 'none'
  },
  '&.EmbersInputSelect-label-blankOptionSelected': {
    display: 'none'
  }
}));
export var StyledInputSelectInput = styled('input')(_objectSpread(_objectSpread(_objectSpread({
  label: 'StyledInputSelectInput'
}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  border: 'none',
  position: 'relative',
  display: 'block',
  flexGrow: 1,
  // the ff - width to 0 then set minWidth - makes the input actually use minWidth
  width: 0,
  minWidth: 60,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis'
}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  color: PROMETHEAN_TEXT_HEADER,
  backgroundColor: 'transparent',
  paddingLeft: 0,
  paddingRight: 0,
  height: 26,
  '&.SelectLaunchButton-input-labelIsInBox': {
    position: 'absolute',
    left: 0,
    width: '100%',
    padding: '0 36px 0 16px'
  },
  '&.SelectLaunchButton-input-dark': {
    '&.SelectLaunchButton-input-placeholderUp': {
      top: 5
    }
  },
  '&.SelectLaunchButton-input-inputIsFilter': {
    textOverflow: 'initial'
  },
  '&.SelectLaunchButton-input-disabled': {
    color: PROMETHEAN_NEUTRAL_DARK_GREY,
    pointerEvents: 'none',
    '&::placeholder': {
      color: PROMETHEAN_NEUTRAL_DARK_GREY
    }
  }
}));
export var StyledInputSelectLaunchButton = styled('div')(_objectSpread(_objectSpread({
  label: 'StyledInputSelectLaunchButton',
  display: 'flex',
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  minHeight: 48
}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  paddingLeft: 16,
  paddingRight: 36,
  paddingTop: 11,
  paddingBottom: 11,
  borderRadius: 4,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
  '&.SelectLaunchButton-disabled': {
    pointerEvents: 'none'
  },
  '&.SelectLaunchButton-dark': {
    backgroundColor: PROMETHEAN_NEUTRAL_WHITE
  },
  '&.SelectLaunchButton-needsTopSpace': {
    paddingTop: 17
  },
  '.SelectLaunchButton-arrowIcon': {
    position: 'absolute',
    color: PROMETHEAN_TEXT,
    right: '8px',
    cursor: 'pointer',
    '&.is-open': {
      transform: 'rotate(180deg)'
    },
    '&.SelectLaunchButton-arrowIcon-disabled': {
      color: PROMETHEAN_NEUTRAL_DARK_GREY,
      pointerEvents: 'none'
    }
  },
  '.icon-loading': {
    position: 'absolute',
    color: PROMETHEAN_TEXT,
    right: '8px'
  },
  // tags - needed this level of specificity to override theme
  '&.SelectLaunchButton-root .InputSelect-tag': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
    color: PROMETHEAN_TEXT_HEADER,
    margin: 0,
    maxWidth: 'calc(100% - 6px)',
    background: 'transparent',
    '.MuiChip-label': {
      padding: 0
    },
    '.MuiChip-deleteIcon': {
      color: PROMETHEAN_TEXT_HEADER,
      fontSize: 24,
      margin: 0,
      marginRight: 16,
      marginLeft: 4
    },
    '&.InputSelect-tag-disabled': {
      pointerEvents: 'none',
      color: PROMETHEAN_NEUTRAL_DARK_GREY,
      '.MuiChip-deleteIcon': {
        color: PROMETHEAN_NEUTRAL_DARK_GREY
      }
    }
  })
}));